<template>
  <div>
    <window-header></window-header>
    <nav-form>
      <!--<template v-slot:after>
        <button v-if="mode == 'new' || mode == 'edit'" class="button button-fill" @click="importLines">
          <fa-icon icon="file-import" />
          <span>Importar líneas</span>
        </button>
      </template>-->
      <template v-slot:actions>
        <li v-if="itemId" @click="exportarLineasCSV('albaran_id')">
          Exportar líneas
        </li>
      </template>
      <template v-slot:reports>
        <li v-for="p in (app.config.plantillas_documento_albaran_proveedor || [])" :key="'pdpc-' + p.codigo"
          @click="openURL(app.urlGeneradorInformesDocumentoPrint, { id: p.codigo, conditions: [['id', '=', itemId]] })"
          :class="{ disabled: !itemId }">
          Documento: {{ p.nombre }}
        </li>
        <li v-for="p in (app.config.plantillas_etiqueta_albaran_proveedor || [])" :key="'pdpc-' + p.codigo"
          @click="openURL(app.urlGeneradorInformesEtiquetaPrint, { id: p.codigo, conditions: [['id', '=', itemId]] })"
          :class="{ disabled: !itemId }">
          Etiquetas: {{ p.nombre }}
        </li>
      </template>
    </nav-form>
    <section>
      <article style="height: 430px">
        <field name="ndoc" widget="char" searchable label="Nº Fabricación" width="110px" style="top: 5px; left: 5px;"
          inputStyle="text-align:right;" />
        <field name="fecha" type="date" label="Fecha" width="100px" style="top: 5px; left: 130px" />
        <field autofocus ref="proveedor_id" name="proveedor_id" widget="m2o" label="Taller" searchable width="320px"
          style="top: 5px; right: 55px" labelProp="nombre_comercial" imgProp="imagen.imagen"
          :filter="[['activo', '=', 1], ['realiza_reparaciones', '=', 1]]" :fields="[
            'nacionalidad',
            { name: 'divisa_id', fields: ['codigo', 'nombre', 'ratio'] },
            { name: 'impuesto_id', fields: ['nombre', 'valor'] },
            'descuento_especial',
            'financiacion',
            { name: 'comentarios', fields: ['descripcion', 'fecha', 'activo'] },
            {
              name: 'forma_pago_id',
              fields: [
                'codigo',
                'descripcion',
                'vencimientos',
                'periodicidad',
                'periodicidad_unidades',
              ],
            },
            'descuento_linea_unidad',
            'descuento_linea_peso',
            'merma',
            'merma_linea'
          ]" />
        <!--<a href="#" v-tooltip="'Mostrar comentarios'" class="button button-plain"
          :class="{ disabled: !formData.proveedor_id }" style="position: absolute; top: 15px; right: 22px"
          @click="mostrarComentariosProveedor">
          <fa-icon icon="sticky-note" />
        </a>-->
        <!--<a href="#" v-tooltip="'Abrir saldos'" class="button button-plain" :class="{ disabled: !formData.proveedor_id }"
          style="position: absolute; top: 15px; right: 5px" @click="abrirSaldos">
          <fa-icon icon="dollar-sign" />
        </a>-->

        <field ref="lineas_fabricacion" name="lineas_fabricacion" class="lineas" :htSettings="{
          rowHeights: 15
        }" widget="handsontable" :height="152" :minRows="8" style="top: 50px; left: 4px; width: 648px"
          customprop="lineas_customprop"
          :fields="[{ name: 'sublineas', fields: ['tipo', 'codigo', 'descripcion', 'unidades', 'peso', 'v', 'precio_coste', 'totallinea', 'precio', { name: 'metal_id', fields: ['factor', 'cotizacion', 'codigo', 'metal'] }] }]"
          :columns="[
            {
              name: 'ean13',
              header: '|||||||||',
              help: 'Código de barras del artículo',
            },
            {
              name: 'modelo_id',
              header: 'Modelo',
              help: 'Modelo del artículo',
              type: 'm2o',
              primary: 'codigo',
              label: 'codigo',
            },
            {
              name: 'articulo_id',
              header: 'Artículo',
              help: 'Código del artículo',
              type: 'm2o',
              primary: 'codigo',
              label: 'codigo',
              noOpen: true,
              fields: [
                { name: 'thumbnail', fields: ['imagen'] },
                { name: 'familia_id', fields: ['codigo', 'nombre'] },
              ],
            },
            {
              name: 'descripcion',
              help: 'Descripción del artículo',
              header: 'Descripción',
            },
            /*{
              name: 'refproveedor',
              header: 'R. Proveedor',
              help: 'Ref. del proveedor del artículo',
            },
            //{name:'familia_id',header:'Familia', type:'m2o', primary:'codigo', label:'codigo', readOnly:true},
            { name: 'nota', header: 'Nota' },*/
            //{name:'tt',header:'T', type:'select', options:['A','R']},
            {
              name: 'almacen_id',
              header: 'Almacén',
              help: 'Almacén',
              type: 'm2o',
              primary: 'codigo',
              label: 'codigo',
              readOnly: true,
            },
            {
              name: 'unidades',
              header: 'Unid.',
              help: 'Unidades',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'etiqueta',
              help: 'Etiquetas',
              header: 'Etiq.',
              type: 'numeric',
            },
            {
              name: 'peso',
              header: 'Peso',
              help: 'Peso',
              type: 'numeric',
              numericFormat: { pattern: '0,0.000' },
            },
            {
              name: 'c',
              header: 'C',
              help: '<U> Compra por unidad <P> Compra por peso',
              type: 'select',
              options: ['U', 'P'],
            },
            {
              name: 'mc',
              header: 'M',
              help: 'Compra con metal incluido',
              type: 'checkbox',
            },
            {
              name: 'precio_coste',
              header: 'PCU',
              help: 'Precio de coste del artículo',
              readOnly: true,
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'totallinea',
              header: 'Total',
              help: 'Precio total línea',
              readOnly: true,
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'v',
              header: 'V',
              help: '<U> Venta por unidad <P> Venta por peso',
              type: 'select',
              options: ['U', 'P'],
            },
            {
              name: 'mv',
              header: 'M',
              help: 'Venta con metal incluido',
              type: 'checkbox',
            },
            {
              name: 'margen',
              header: '%',
              help: '% de Margen comercial',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'pventa',
              header: 'P.Venta',
              help: 'Precio de Vta. al cliente',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'tarifa',
              header: 'T',
              help: 'Tarifa en la que se grabará el P.Venta',
              type: 'numeric',
              numericFormat: { pattern: '0,0' },
            }
          ]" />
        <field ref="sublineas" :name="`lineas.${rowSelected}.sublineas`" class="lineas" :readonly="rowSelected === null"
          :htSettings="{
            rowHeights: 15,
            cells: cellsSublineas,
          }" widget="handsontable" :height="152" :minRows="8" style="top: 200px; left: 4px; width: 648px" :columns="[
            {
              name: 'tipo',
              header: 'T',
              help: '<A> Artículo/materia prima <O> Otros costes',
              type: 'select',
              options: ['A', 'O'],
            },
            {
              name: 'codigo',
              header: 'Código'
            },
            {
              name: 'descripcion',
              help: 'Descripción del artículo',
              header: 'Descripción',
              readOnly: true,
            },
            {
              name: 'metal_id',
              header: 'Metal',
              type: 'm2o',
              primary: 'codigo',
              label: 'metal',
              model: 'metal',
              fields: ['factor', 'metal', 'cotizacion']
            },
            {
              name: 'unidades',
              header: 'Unid.',
              help: 'Unidades',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'peso',
              header: 'Peso',
              help: 'Peso',
              type: 'numeric',
              numericFormat: { pattern: '0,0.000' },
            },
            {
              name: 'precio',
              header: 'Precio',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
            },
            {
              name: 'v',
              header: 'V',
              help: 'Valoración a <U> Unidad o a <P> Peso',
              type: 'select',
              options: ['U', 'P'],
            },
            {
              name: 'precio_coste',
              header: 'PCU',
              help: 'Precio de coste del artículo/trabajo',
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
              readOnly: true,
            },
            {
              name: 'totallinea',
              header: 'Total',
              help: 'Total de la línea',
              readOnly: true,
              type: 'numeric',
              numericFormat: { pattern: '0,0.00' },
              readOnly: true,
            },
          ]" />
        <field name="adjuntos" :max="6" widget="files" label="Adjuntos" style="bottom: 15px; left: 11px" />
        <field name="total_unidades" widget="float" type="number" dec="2" label="Total Unidades" width="70px"
          style="bottom: 15px; right: 175px" :readonly="true" />
        <field name="total_peso" widget="float" type="number" dec="3" label="Total Peso" width="70px"
          style="bottom: 15px; right: 95px" :readonly="true" suffix=" g" />
        <field name="total_articulos" widget="float" type="number" dec="2" label="Total Artículos" width="70px"
          style="bottom: 15px; right: 15px" :readonly="true" />

        <!-- tabs -->
      </article>
    </section>
    <v-collapse-wrapper ref="main-collapse" :active="true">
      <div class="header" v-collapse-toggle>
        Listado
        <div class="item-after">
          <!--<field widget="select" name="anio" style="position: relative; width: 100px; margin-right: 24px;" width="100"
            @click="$event.stopPropagation()" :options="years.reduce((a, v) => ({ ...a, [v]: v }), {})" searchable
            :readonly="mode != 'search'" placeholder="Todos los años" v-if="years.length" />-->
          {{ count }}
        </div>
      </div>
      <div class="my-content" v-collapse-content>
        <hot-table ref="hotTableComponent" :settings="htSettings"></hot-table>
      </div>
    </v-collapse-wrapper>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import rTableMixin from "./../components/rTableMixin.vue";
/*import CompraMixin from "./../components/CompraMixin.js";
import FacturaMixin from "./../components/FacturaMixin.vue";*/

export default {
  mixins: [WindowMixin, rFormMixin, rTableMixin],
  data: function () {
    var self = this;
    return {
      title: "Fabricación",
      dbAdapter: "fabricacion",
      primary: "id",
      defaultDataSearch: {
        //wt: 0,
        //anio: new Date().getFullYear(),
      },
      defaultData: {
        //wt: 0,
        fecha: new Date().yyyymmdd(),
        delegacion_id: self.app.config.delegacion_defecto || null,
        cambio: 1 //fix
      },
      sequence: { name: "fabricacion", field: "ndoc" },
      rowSelected: null
    };
  },
  mounted() {
    var self = this;

    let hLineas = self.$refs.lineas_fabricacion.field.hotInstance;

    self.$refs.lineas_fabricacion.field.hotInstance.addHook('afterSelectionEndByProp', function (row) {
      let h = this;
      let d = h.getSourceData()[row];
      if (d.articulo_id) {
        self.rowSelected = row;
      } else {
        self.rowSelected = null;
      }
    });

    self.$refs.lineas_fabricacion.field.hotInstance.addHook('afterChange', function (changes, source) {
      if (source == 'loadData') return;
      if (!changes) return;
      var h = this;
      changes.forEach(function (change, index) {
        if (!change) return;
        var row = change[0];
        var prop = change[1];
        var oldVal = change[2];
        var newVal = change[3];
        let d = h.getSourceData()[row];

        if (((prop == 'ean13' || prop == 'articulo_id') && newVal && source != 'auto') || source == 'newproduct') {
          // Fix ean13
          if (prop == 'ean13' && newVal.length == 12) newVal = '0' + newVal;
          if (prop == 'ean13' && newVal.includes(',')) {
            newVal = parseInt(newVal.replace('.', '')).toString();
            newVal = newVal.padStart(7, '0');
            const ean_checkdigit = (code) => {
              let sum = 0;
              for (let i = 0; i < code.length; i++) {
                sum += (((i + 1) % 2) * 2 + 1) * code[code.length - 1 - i];
              }
              return code + (10 - (sum % 10)) % 10;
            }
            newVal = ean_checkdigit(newVal);
          }

          let p = window.DB.getList('articulo', {
            limit: 1,
            filter: [prop == 'articulo_id' ? 'codigo' : 'ean13', "=", newVal],
            depth: 3,
            fields: [
              'codigo',
              'ean13',
              { name: 'modelo_id', fields: ['codigo', 'nombre'] },
              { name: 'familia_id', fields: ['codigo', 'nombre'] },
              'nombre',
              'unidad_medida_compra',
              'compra_metal_incluido',
              'precio_coste',
              'coste_unidad_venta',
              'unidad_medida_venta',
              'venta_metal_incluido',
              'peso_unitario_fino',
              'margen_ultima_compra',
              { name: 'thumbnail', fields: ['imagen'] },
              'precio_coste_hechura_euros'
            ]
          });

          p.then(function (res) {
            if (parseInt(res.count)) {
              const a = res.data[0];
              h.setDataAtRowProp([
                [row, 'ean13', a.ean13],
                [row, 'articulo_id', a],
                [row, 'descripcion', a.nombre],
                [row, 'almacen_id', self.app.config.almacen_defecto || null],
                [row, 'unidades', 1],
                [row, 'etiqueta', 1],
                [row, 'peso', a.peso_unitario_fino || 0],
                [row, 'v', a.unidad_medida_venta == 'peso' ? 'P' : 'U'],
                [row, 'm', parseInt(a.venta_metal_incluido) ? 1 : 0],
                [row, 'precio_coste', 0],
                [row, 'margen', 0],
                [row, 'pventa', 0],
                [row, 'tarifa', 1],
              ], 'auto')

            } else {
              self.app.toast('No se han encontrado el artículo', 'error');
              h.setDataAtRowProp(row, prop, oldVal, 'auto');
            }
          }).catch(function (res) {
            window.console.log(res);
          });
        }

        if (prop == 'precio_coste' || prop == 'peso' || prop == 'unidades' || prop == 'c') {
          const totallinea = (d.precio_coste || 0) * (d.c == 'P' ? (d.peso || 0) : (d.unidades || 0));
          h.setDataAtRowProp(row, "totallinea", totallinea, "auto")
        }

        if (prop == 'margen' || prop == 'precio_coste') {
          var precio_venta = (1 + ((d.margen || 0) / 100)) * (d.precio_coste || 0);
          h.setDataAtRowProp(row, "pventa", precio_venta, "auto")
        }

        if (prop == 'peso') {
          const total_peso = h.getSourceData().reduce((acc, v) => acc + (v.peso || 0), 0)
          //self.formData.total_peso = h.getSourceData().reduce((acc, v) => acc + (v.peso || 0), 0)
          self.$set(self.formData, 'total_peso', total_peso);
        }
        if (prop == 'unidades') {
          const total_unidades = h.getSourceData().reduce((acc, v) => acc + (v.unidades || 0), 0)
          //self.formData.total_unidades = h.getSourceData().reduce((acc, v) => acc + (v.unidades || 0), 0)
          self.$set(self.formData, 'total_unidades', total_unidades);
        }
        if (prop == 'totallinea') {
          const total_articulos = h.getSourceData().reduce((acc, v) => acc + (v.totallinea || 0), 0);
          //self.formData.total_articulos = total_articulos
          self.$set(self.formData, 'total_articulos', total_articulos);
        }
      });
    });

    self.$refs.sublineas.field.hotInstance.addHook('afterChange', function (changes, source) {
      if (source == 'loadData') return;
      if (!changes) return;
      var h = this;
      changes.forEach(function (change, index) {
        if (!change) return;
        var row = change[0];
        var prop = change[1];
        var oldVal = change[2];
        var newVal = change[3];
        let d = h.getSourceData()[row];
        //window.console.log(row, prop, oldVal, newVal, source);

        if (prop == 'codigo' && oldVal != newVal && source != 'auto') {
          let p;
          if (d.tipo == 'A') {
            p = window.DB.getList('articulo', {
              limit: 1,
              filter: [['codigo', "=", newVal],],//['es_materia_prima', '=', 1]
              depth: 3,
              fields: ['codigo', 'nombre', 'peso_unitario_fino', 'precio_coste_hechura_euros']
            })
          } else {
            p = window.DB.getList('coste_fabricacion', {
              limit: 1,
              filter: ['codigo', "=", newVal],
              depth: 3,
              fields: ['codigo', 'descripcion', 'precio']
            })
          }

          p.then(function (res) {
            if (parseInt(res.count)) {
              let a = res.data[0];
              let datarows = [
                [row, 'codigo', a.codigo],
                [row, 'descripcion', d.tipo == 'A' ? a.nombre : a.descripcion],
                [row, 'unidades', 1],
                [row, 'peso', d.tipo == 'A' ? a.peso_unitario_fino : 0],
                [row, 'v', 'U'],
                [row, 'margen', 0],
                [row, 'precio_coste', d.tipo == 'A' ? a.precio_coste_hechura_euros : a.precio],
              ];
              datarows.push([row, d.tipo == 'A' ? 'articulo_id' : 'coste_fabricacion_id', a.codigo]);
              h.setDataAtRowProp(datarows, 'auto');


            } else {
              h.setDataAtRowProp(row, prop, oldVal, 'auto');
            }
          }).catch(function (err) {
            window.console.error(err);
          });
        }

        if (prop == 'unidades' || prop == 'precio_coste') {
          const totallinea = (d.unidades || 0) * (d.precio_coste || 0);
          //window.console.log(row, prop, totallinea);
          h.setDataAtRowProp(row, 'totallinea', totallinea.toFixed(2), 'auto');
        }

        const metal = (typeof d.metal_id == "object" ? d.metal_id : h.cachedItems['metal_id']?.[d.metal_id]) || {};
        const factor = metal?.factor || 1;

        if ((prop == 'metal_id' || prop == 'precio' || prop == 'peso' || prop == 'unidades' || prop == 'v')) {
          const precio_coste = d.v == 'P' ?
            (d.precio || 0) * factor * (d.peso || 0) / (d.unidades || 1) :
            factor * (d.precio || 0)
          h.setDataAtRowProp(row, 'precio_coste', precio_coste.toFixed(2), 'auto');
        }

        if (prop == 'metal_id') {
          h.setDataAtRowProp(row, 'precio', (metal.cotizacion || 0).toFixed(2), 'auto');
        }

        if (prop == 'unidades' && oldVal != newVal) {
          const peso = oldVal ? newVal * (d.peso || 0) / oldVal : 0;
          h.setDataAtRowProp(row, 'peso', peso.toFixed(2), 'auto');
        }



        if (prop == 'totallinea') {
          let coste_total = h.getSourceData().reduce((acc, prev) => acc + (prev.totallinea || 0), 0);
          hLineas.setDataAtRowProp(self.rowSelected, 'precio_coste', coste_total, 'auto');
          //self.formData.lineas[self.rowSelected].precio_coste = coste_total;
        }

        if (prop == 'peso') {
          const peso_total = h.getSourceData().reduce((acc, prev) => acc + (prev.tipo == 'A' && (prev.peso || 0)), 0);
          hLineas.setDataAtRowProp(self.rowSelected, 'peso', peso_total, 'auto');
        }

      });
    });

    ["loadItem", "save"].forEach(ev => {
      self.$on(ev, function (params) {
        self.formData.lineas = self.formData.lineas_fabricacion
      });
    })

  },
  methods: {
    cellsSublineas: function (row, col, prop) {
      const self = this;
      let cellProperties = {};
      let h = self.$refs?.sublineas?.field?.hotInstance;
      let d = h?.getSourceData()[row];

      if (h) {
        if (prop != "tipo" && d && !d.tipo) {
          cellProperties.readOnly = true;
        }
        if (prop == 'metal_id' && d?.tipo != 'A') {
          cellProperties.readOnly = true;
        }
      }




      return cellProperties;
    },
  },
};
</script>